import React from "react";
import { IyourPresentationButtonComponentProps } from "../types/props";
import "./yourPresentationButtonComponent.scss";

function YourPdfButtonComponent({ count, openTray, trayOpen }: IyourPresentationButtonComponentProps) {
  if (!trayOpen) {
    return (
      <button className="presentation-button" onClick={() => openTray()}>
        <i>
          <span>{count}</span>
        </i>
        Your Presentation
      </button>
    );
  }
  return null;
}

export default YourPdfButtonComponent;
